/**
 * Base URL de l’API Paiement (processus séparé).
 * En prod (Cloudflare Pages), si REACT_APP_PAYMENT_API_URL est vide,
 * on retombe sur REACT_APP_API_URL — sinon le POST relatif frappe alphasniper.io
 * (Pages) au lieu de api.alphasniper.io → 405 / “Payment could not be started”.
 * En local, laisser les deux vides : le proxy CRA envoie les routes paiement vers :5001.
 */
import { getApiOrigin } from "utils/apiUrl";

export function getPaymentApiOrigin() {
  const dedicated = String(process.env.REACT_APP_PAYMENT_API_URL || "")
    .trim()
    .replace(/\/$/, "");
  if (dedicated) return dedicated;
  return getApiOrigin();
}

/**
 * @param {string} path - ex. /api/client/slot-payment
 */
export function paymentApiUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  const origin = getPaymentApiOrigin();
  if (!origin) return p;
  return `${origin}${p}`;
}
